import { isEmpty } from '../../../helpers/objectValidator.helper';
import { Draft } from 'immer';
import { changeInput, handleCaptchaResponse, handleLMSResponse } from '../action';
import { FormDataType, StateProps } from '../interface';

export const initStoreHandler = (draft: Draft<StateProps>, state: Partial<StateProps>) => {
    draft.error = undefined;
    draft.responseData = undefined;

    if (state.address) {
        draft.address = state.address;
        draft.formData = {
            city: state.address.city ?? '',
            streetName: state.address.street,
            streetNr: `${state.address.housenumber}${state.address.housenumberextra ?? ''}`,
            postcode: state.address.zipcode ?? '',
        };
    }
};

export const captchaResponseHandler = (
    draft: Draft<StateProps>,
    { captchaState, error }: ReturnType<typeof handleCaptchaResponse>
) => {
    if (captchaState && !isEmpty(captchaState)) {
        const { validatorUrl, captchaMediaType, hash } = captchaState;

        draft.captcha = {
            ...draft.captcha,
            validatorUrl,
            captchaMediaType,
            hash,
        };
    }

    if (error && !isEmpty(error)) {
        draft.captcha = {
            ...draft.captcha,
            error,
        };
    }

    draft.loading = false;
};

export const changeInputHandler = (
    draft: Draft<StateProps>,
    state: StateProps,
    action: ReturnType<typeof changeInput>
) => {
    const { update } = action;
    const filteredFormData: FormDataType = {};

    // filter out empty optional input values with empty string from state
    Object.keys(update).forEach((key) => {
        filteredFormData[key] = '' !== update[key] ? update[key] : undefined;
    });

    draft.formData = {
        ...state.formData,
        ...filteredFormData,
    };

    if (update?.captchaAnswer && ('string' === typeof update.captchaAnswer)) {
        draft.captcha = {
            ...state.captcha,
            answer: update.captchaAnswer,
        };
    }
};

export const lmsResponseHandler = (
    draft: Draft<StateProps>,
    { payload, error }: ReturnType<typeof handleLMSResponse>
) => {
    draft.loading = false;
    draft.responseData = undefined;
    draft.error = undefined;

    if (payload && !isEmpty(payload)) {
        draft.responseData = { ...payload };
    }

    if (error && !isEmpty(error)) {
        draft.error = { ...error };
    }
};
